var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fullpageitem"},[_c('div',{staticClass:"container"},[_c('p',{staticClass:"emailtext",on:{"click":function($event){_vm.goHome()}}}),_vm._v(" "),_c('a',{staticClass:"emaillink",attrs:{"href":"mailto:info@secondeditions.net"}},[_vm._v("info@secondeditions.net")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5af22f98","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContactPage.vue
// module id = null
// module chunks = 